module.exports = __webpack_public_path__ + "img/circle.524d3480.png";